class MedCalendarsController {

    constructor() {
        'ngInject';
    }

    $onInit() {
        this.setupSchedules(this.patient)
    }

    $onChanges(changes) {
        if (changes.patient) {
            this.setupSchedules(changes.patient.currentValue)
        }
    }

    setupSchedules(patient) {
        this.availableSchedules = patient.schedule.schedules
        this.selectedSchedules = []
        if (patient.schedule.schedules) {
            this.selectedSchedules.push(patient.schedule.schedules[0].type)
        }
    }

    toggleScheduleSelected(schedule) {
        const index = this.selectedSchedules.findIndex(s => s === schedule)
        if (index !== -1) {
            const clone = this.selectedSchedules.slice()
            clone.splice(index, 1)
            this.selectedSchedules = clone
        } else {
            // maintain same schedule type order regardless of add/remove cycles
            this.selectedSchedules = this.patient.schedule.schedules
                .map(schedule => schedule.type)
                .filter(type => this.selectedSchedules.includes(type) || type === schedule)
        }
    }

    print() {
        const frame = document.getElementById('pdfViewer')
        frame.contentWindow.focus();
        frame.contentWindow.print();
    }
}

export const MedCalendarsComponent = {
    name: 'medCalendars',
    component: {
        template: `
            <schedule-pdf patient="$ctrl.patient" schedule-types="$ctrl.selectedSchedules" on-file-ready-changed="$ctrl.isFileReady = isFileReady"></schedule-pdf>
            <schedule-picker available-schedules="$ctrl.availableSchedules" selected-schedules="$ctrl.selectedSchedules"
                on-schedule-selected-toggle="$ctrl.toggleScheduleSelected(scheduleType)" on-print="$ctrl.print()" is-file-ready="$ctrl.isFileReady"></schedule-picker>
        `,
        controller: MedCalendarsController,
        bindings: {
            patient: '<'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/medCalendars.component.js